import React from "react";

class Page3 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 3) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div className="container-fluid h-100 vertical-center ">
            <div className="row h-100 justify-content-center">
              <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                <div className="card mb-4 box-shadow" id="pageContent">
                  <div className="card-body d-flex flex-column text-dark">
                    <span id="moduleContentText_2">
                      It sounds like a cliché, but finding a career really is a
                      journey; sometimes you know what you want to do, and other
                      times you stumble across it. Whilst a large proportion of
                      the UK market is degree neutral other countries may have a
                      different approach to recruitment. Therefore the more
                      research you do the better informed you will be.
                      <br />
                      <br />
                      <ol>
                        <li>
                          <strong>Analyse market trends:</strong> entire sectors
                          are changing, stay ahead of recruitment patterns and
                          focus on sectors that are healthy. Resources such as
                          the{" "}
                          <a
                            target="_blank"
                            href="http://cdn.theatlantic.com/static/front/docs/sponsored/phoenix/future_work_skills_2020.pdf"
                          >
                            Future Work Skills
                          </a>{" "}
                          report can be helpful in identifying wider employment
                          trends.
                        </li>
                        <br />
                        <li>
                          <strong>70/30 Rule:</strong> Go back to your shopping
                          list of strengths and values. If a potential job or
                          sector meets 70% of what you need then it is worth
                          applying. After all there is no such thing as a
                          perfect job.
                        </li>
                        <br />
                        <li>
                          <strong>How do you make decisions:</strong> How did
                          you decide to study at Bath? What factors influenced
                          your decision? Did you for example write a pros and
                          cons list or follow your gut instinct? Could you apply
                          the same decision making process to your future career
                          choice?
                        </li>
                      </ol>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page3;
